export const isValidNumber = (value: number | string | null | undefined) => {
  return (Boolean(value) || value === 0) && !isNaN(Number(value));
};
